import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { giveGetEligibilityBackend } from './give-get-eligibility.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { giveGetEligibilityReducer } from './give-get-eligibility.reducer';

// FIXME: remove that
backend.giveGetEligibility = giveGetEligibilityBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('giveGetEligibility', giveGetEligibilityReducer),
    /* DatastoreBackendModule.forFeature(
      'giveGetEligibility',
      giveGetEligibilityBackend,
    ),*/
  ],
})
export class DatastoreGiveGetEligibilityModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/give-get-eligibility/give-get-eligibility.module.ts